import { render, staticRenderFns } from "./AddPhone.vue?vue&type=template&id=4252ecaa&scoped=true"
import script from "./AddPhone.vue?vue&type=script&lang=ts"
export * from "./AddPhone.vue?vue&type=script&lang=ts"
import style0 from "./AddPhone.vue?vue&type=style&index=0&id=4252ecaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252ecaa",
  null
  
)

export default component.exports